'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reactRedux = require('react-redux');

var _setup = require('redux/modules/setup');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownloadAppPopup = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    popupDisplayed: state.setup.popupDownloadAppDisplayed
  };
}, { hideDownloadAppPopup: _setup.hideDownloadAppPopup }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DownloadAppPopup, _Component);

  function DownloadAppPopup() {
    (0, _classCallCheck3.default)(this, DownloadAppPopup);
    return (0, _possibleConstructorReturn3.default)(this, (DownloadAppPopup.__proto__ || (0, _getPrototypeOf2.default)(DownloadAppPopup)).apply(this, arguments));
  }

  (0, _createClass3.default)(DownloadAppPopup, [{
    key: 'downloadApp',
    value: function downloadApp() {
      window.open('https://lok.to/w2app', '_blank').focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./DownloadAppPopup.scss');
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        {
          show: this.props.popupDisplayed,
          hide: this.props.hideDownloadAppPopup,
          className: 'modal-download-mobile'
        },
        _react2.default.createElement(
          'div',
          {
            className: 'close-modal-button',
            onClick: this.props.hideDownloadAppPopup
          },
          _react2.default.createElement('i', { className: 'fa fa-times' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.modalDownload },
          _react2.default.createElement('img', { className: styles.bgRect, src: '/download/bg-rect.svg' }),
          _react2.default.createElement('img', { className: styles.bgStars, src: '/download/bg-stars.svg' }),
          _react2.default.createElement('img', { className: styles.bgEllipse, src: '/download/bg-ellipse.svg' }),
          _react2.default.createElement('img', { className: styles.headerImage, src: '/download/download-popup.svg' }),
          _react2.default.createElement(
            'p',
            { className: styles.ctaText },
            'Vui l\xF2ng t\u1EA3i \u1EE9ng d\u1EE5ng Lookme \u0111\u1EC3 \u0111\u1EB7t l\u1ECBch ti\u1EC7n l\u1EE3i h\u01A1n b\u1EA1n nh\xE9 \uD83E\uDDE1'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.actionButtons },
            _react2.default.createElement(
              'div',
              {
                className: styles.btnDownload,
                onClick: function onClick() {
                  return _this2.downloadApp();
                }
              },
              'T\u1EA2I APP NGAY'
            )
          )
        )
      );
    }
  }]);
  return DownloadAppPopup;
}(_react.Component), _class2.propTypes = {
  popupDisplayed: _react.PropTypes.bool.isRequired,
  hideDownloadAppPopup: _react.PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = DownloadAppPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/DownloadAppPopup.js
// module id = 1574
// module chunks = 0